import { Component } from '@angular/core';
import { SharedService } from "./shared/shared.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  showLeftMenu: boolean = true;
  showAdminHome: boolean = SharedService.showAdminApp;
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts